import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router';
import { getEminitiesList } from 'app/api/eminities';
import { getMallList } from 'app/api/mall';
import {
  addSupportServices,
  getSupportServicesById,
  updateSupportServices,
} from 'app/api/supportservices';
import {
  supportServiceValidationRules,
  validate,
} from 'app/constants/validation-constants';
import Message from 'app/utils/Message';
import Toast from 'app/utils/Toast';

const useCreateMallSupportService = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [pageLoading, setPageLoading] = useState(false);
  const [mallList, setMallList] = useState([]);
  const [eminitiesList, setEminitiesList] = useState([]);
  const [error, setErrors] = useState({});
  const [values, setValues] = useState({
    serviceId: '',
    mallId: '',
    contactNumber: '',
    contactPersonName: '',
    status: true,
  });

  const supportId = location?.state?.id ? location?.state?.id : '';

  useEffect(() => {
    getMallListforDropdown();
    getEminities();
    if (supportId) {
      loadStoreData(supportId);
    }
  }, [supportId]);

  const getMallListforDropdown = async () => {
    setPageLoading(true);
    let response = await getMallList(1);
    setPageLoading(false);
    if (response && response?.responseCode === 200) {
      let temp = await response?.data?.malls?.map((item, index) => {
        return {
          ...item,
          value: item.id,
          label: item.name,
        };
      });
      setMallList(temp);
    } else {
      Toast.error(
        response?.data ? response?.data : Message?.Error?.COMMON_MESSAGE
      );
    }
  };
  const getEminities = async () => {
    setPageLoading(true);
    let response = await getEminitiesList(1);
    setPageLoading(false);
    if (response && response?.responseCode === 200) {
      let temp = await response?.data?.emitites?.map((item, index) => {
        return {
          ...item,
          value: item.id,
          label: item.name,
        };
      });
      setEminitiesList(temp);
    } else {
      Toast.error(
        response?.data?.message
          ? response?.data?.message
          : Message.Error.COMMON_MESSAGE
      );
    }
  };

  async function loadStoreData(id) {
    if (!id) {
      return;
    }

    setPageLoading(true);
    let response = await getSupportServicesById(id);
    setPageLoading(false);
    if (response?.responseCode === 200) {
      let responsedata = response?.data;

      setValues({
        serviceId: responsedata?.serviceId?.id,
        mallId: responsedata?.mallId?.id,
        contactNumber: responsedata?.contactNumber,
        contactPersonName: responsedata?.contactPersonName,
        status: responsedata?.status,
      });
    } else {
      Toast.error(
        response?.response?.message
          ? response?.response?.message
          : Message.Error.COMMON_MESSAGE
      );
    }
  }

  async function callAddOrUpdateAPI() {
    setPageLoading(true);
    let response = {};

    if (supportId) {
      response = await updateSupportServices(supportId, { ...values });
    } else {
      response = await addSupportServices({ ...values });
    }
    setPageLoading(false);

    if (response?.responseCode === 200) {
      Toast.success(
        supportId
          ? Message.Support_Service.UPDATED_SUCCESS
          : Message.Support_Service.CREATED_SUCCESS
      );
      navigate(-1);
    } else {
      Toast.error(
        response?.response?.message
          ? response?.response?.message
          : Message.Error.COMMON_MESSAGE
      );
    }
  }

  function handleCreateMallSupportService(e) {
    e.preventDefault();
    const validationErrors = validate(values, supportServiceValidationRules);
    setErrors(validationErrors);

    if (Object.keys(validationErrors).length === 0) {
      callAddOrUpdateAPI();
    }
  }

  function handleChange(e) {
    if (e && e.target) {
      const { name, value } = e.target;
      setValues({
        ...values,
        [name]: name === 'contact_number' ? parseInt(value) : value,
      });

      if (error[name]) {
        setErrors({
          ...error,
          [name]: '',
        });
      }
    }
  }
  function setChange(name, val) {
    setValues((prevState) => ({
      ...prevState,
      [name]: val,
    }));
    setErrors({
      ...error,
      [name]: '',
    });
  }

  return {
    setChange,
    handleChange,
    values,
    error,
    handleCreateMallSupportService,
    pageLoading,
    supportId,
    mallList,
    eminitiesList,
    navigate,
  };
};
export default useCreateMallSupportService;
